import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles, withWidth, Card, Grid } from '@material-ui/core';
import { isWidthUp } from '@material-ui/core/withWidth';

class FHETimeline extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        width: PropTypes.string.isRequired,
        events: PropTypes.array.isRequired
    };

    renderTimelineElement = (event, isLeft) => {
        const { classes } = this.props;

        return (
            <div className={classes.cardContainer}>
                <div
                    className={`${classes.cardDecorator} ${isLeft ? classes.cardDecoratorLeft : classes.cardDecoratorRight} ${
                        event.position === 'left' ? classes.colorFromFhe : classes.colorToFhe
                    }`}
                />
                <div className={classes.titleHeader}>
                    <div className={classes.titleHeaderUser}>{event.supporUserName}</div>
                    {event.actionLabel}
                </div>
                <Card className={event.position === 'left' ? classes.backgroundColorFromFhe : classes.backgroundColorToFhe}>
                    <div className={classes.cardContent}>
                        {event.content.split('\n').map((item, key) => {
                            return (
                                <span key={key}>
                                    {item}
                                    <br />
                                </span>
                            );
                        })}
                    </div>
                </Card>
                <div className={classes.dateFooter}>{event.date} </div>
            </div>
        );
    };

    renderTimeline = () => {
        const { classes, events, width } = this.props;
        let res = [];
        events.map((event, i) => {
            const position = isWidthUp('md', width) ? event.position : 'right';

            if (isWidthUp('md', width)) {
                res.push(
                    <Grid container item md={5} key={'left-' + i}>
                        {position === 'left' && this.renderTimelineElement(event, true)}
                    </Grid>
                );
            }
            res.push(
                <Grid container item xs={2} key={'icon-' + i} className={classes.iconGrid}>
                    <div className={classes.line} />
                    <div
                        className={`${classes.iconContainer} ${
                            event.position === 'left' ? classes.backgroundColorFromFhe : classes.backgroundColorToFhe
                        }`}
                    >
                        {event.icon}
                    </div>
                </Grid>,
                <Grid container item xs={10} md={5} key={'right-' + i}>
                    {position === 'right' && this.renderTimelineElement(event, false)}
                </Grid>
            );
        });
        return res;
    };

    render() {
        const { classes } = this.props;

        return (
            <Grid container className={classes.container}>
                {this.renderTimeline()}
            </Grid>
        );
    }
}

const styles = theme => ({
    container: {
        padding: 10
    },
    titleHeader: {
        display: 'flex',
        fontSize: '0.8em'
    },
    titleHeaderUser: {
        fontWeight: 'bold',
        marginRight: 3
    },
    dateFooter: {
        fontSize: '0.8em',
        display: 'flex',
        justifyContent: 'flex-end'
    },
    iconGrid: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    iconContainer: {
        zIndex: 0,
        color: theme.palette.background.paper,
        borderRadius: '50%',
        padding: 5,
        display: 'flex'
    },
    line: {
        position: 'absolute',
        left: 'calc(50% - 1px)',
        width: '2px',
        height: '100%',
        backgroundColor: theme.palette.grey.A100
    },
    cardContainer: {
        position: 'relative',
        margin: 5
    },
    cardContent: {
        padding: 16
    },
    backgroundColorFromFhe: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.background.paper
    },
    backgroundColorToFhe: {
        backgroundColor: theme.palette.warning.main,
        color: theme.palette.background.paper
    },
    colorFromFhe: {
        color: theme.palette.primary.main
    },
    colorToFhe: {
        color: theme.palette.warning.main
    },
    cardDecorator: {
        position: 'absolute',
        width: 0,
        height: 0,
        borderTop: '12px solid transparent',
        borderBottom: '12px solid transparent',
        top: 'calc(50% - 12px)'
    },
    cardDecoratorLeft: {
        borderLeft: `12px solid`,
        left: '100%'
    },
    cardDecoratorRight: {
        borderRight: `12px solid`,
        right: '100%'
    }
});

export default withWidth()(withStyles(styles, { withTheme: true })(FHETimeline));



// WEBPACK FOOTER //
// ./data/components/FHETimeline.js